// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconArrowDown = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M53.3426 33.384C52.4481 32.4895 51.5104 31.5519 50.616 30.6573C49.7214 29.7629 48.6008 29.7827 47.7385 30.7083C47.1939 31.2927 40.2182 38.7803 35.1487 44.2219C35.3991 34.8047 35.9767 13.0613 35.9992 12.0691C36.0281 10.801 35.2451 10 33.9766 10H30.0234C28.755 10 27.9719 10.801 28.0008 12.0691C28.0233 13.0613 28.601 34.8047 28.8513 44.2219C23.7818 38.7803 16.806 31.2926 16.2615 30.7083C15.3992 29.7827 14.2785 29.7628 13.384 30.6573C12.4895 31.5519 11.5518 32.4895 10.6574 33.384C9.76283 34.2786 9.78267 35.3992 10.7082 36.2615C11.6337 37.1238 29.7785 54.028 30.6366 54.8274C31.4948 55.627 32.5053 55.627 33.3634 54.8274C34.2214 54.028 52.3662 37.1239 53.2918 36.2615C54.2173 35.3992 54.2371 34.2786 53.3426 33.384Z" />
    </svg>
  );
};
